import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <div className={styles.itemSelling}>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1725594352445/pc_ksp_04.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1725594352445/pc_ksp_04.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1725594664441/m_ksp_04.jpg"
            />
            <div className="item-desc-d">
                <div className="item-line-1">{t('d_ms1')}</div>
            </div>
        </div>
    );
}
